<div class="flex align-items-center flex-wrap">
  <div class="text-800 text-2xl font-medium mr-4">{{ 'MYOPIA_SINGLE_VISIT_EIM_TITLE' | translate }}</div>
  <div class="border-round-2xl px-2 py-1" [ngStyle]="{ backgroundColor: greyColor, color: whiteColor }">{{ retestString }}</div>
  <div class="mt-4" [innerHTML]="eimString"></div>
</div>
